import { ConfigurationTypes } from '../../core/src/const/ConfigurationTypes';
import IBetConfig, { CurrencyType } from '../../core/src/managers/contracts/configurations/IBetConfig';
import BetModel from '../../core/src/model/BetModel';
export default abstract class AbstractVendorBetConfig implements IBetConfig {
    public type: ConfigurationTypes = ConfigurationTypes.BET;
    public betOptions = [];
    public getBetOptions(): number[] {
        let result = [];
        if (this.betOptions.length > 0) {
            if (BetModel.creditValues.length <= this.betOptions.length) {
                result = BetModel.creditValues;
            } else {
                let validBets = [...BetModel.creditValues];
                // push first valid bet
                result.push(validBets.shift());
                // push last valid bet
                result.push(validBets.pop());
                validBets.forEach(bet => {
                    if (this.betOptions.includes(bet)) {
                        result.push(bet)
                    }
                })
            }
            // this.betOptions.forEach(bet => {
            //     if (BetModel.creditValues.includes(bet)) {
            //         result.push(bet)
            //     }
            // })
        } else {
            result = BetModel.creditValues;
        }
        return result.sort((a, b) => a - b)
    };

    public primaryCurrencyType: CurrencyType = CurrencyType.Coins;
    public alternativeCurrencyType: CurrencyType = CurrencyType.Money;
}
